"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _LinearProgress = _interopRequireDefault(require("@material-ui/core/LinearProgress"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _excluded = ["aria-label", "dataMetrics"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var defaultProps = {
  dataMetrics: {
    root: 'fuse_linear_progress'
  },
  variant: 'indeterminate'
};
var LinearProgress = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var _ref$ariaLabel = _ref['aria-label'],
    ariaLabel = _ref$ariaLabel === void 0 ? 'linear-progress' : _ref$ariaLabel,
    dataMetrics = _ref.dataMetrics,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var mergedDataMetrics = _objectSpread({}, defaultProps.dataMetrics, {}, dataMetrics);
  return /*#__PURE__*/_react["default"].createElement(_LinearProgress["default"], (0, _extends2["default"])({
    ref: ref,
    "aria-label": ariaLabel,
    "data-metrics": mergedDataMetrics.root
  }, rest));
});
LinearProgress.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * attribute used to define a string that labels the current element. Use for accessibility
   */
  'aria-label': _propTypes["default"].string,
  /**
   * Override or extend the styles applied to the component.
   * See [Material UI CSS API](https://v4.mui.com/api/linear-progress/#css)for more details.
   */
  classes: _propTypes["default"].object,
  /**
   * @ignore
   */
  className: _propTypes["default"].string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes["default"].oneOf(['primary', 'secondary']),
  /**
   * Override the data-metrics attributes applied to the component.
   */
  dataMetrics: _propTypes["default"].shape({
    root: _propTypes["default"].string
  }),
  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: _propTypes["default"].number,
  /**
   * The value for the buffer variant.
   * Value between 0 and 100.
   */
  valueBuffer: _propTypes["default"].number,
  /**
   * The variant to use.
   * Use indeterminate or query when there is no progress value.
   */
  variant: _propTypes["default"].oneOf(['determinate', 'indeterminate', 'buffer', 'query'])
} : {};
LinearProgress.defaultProps = defaultProps;
var _default = LinearProgress;
exports["default"] = _default;